import { Button } from '../../components/common/Button';
import { useAuth } from '../../contexts/AuthContext';
import { DEFAULT_POST_AUTH_PATH } from '../../rbac/landingPage';

export default function UnauthorizedAccessPage() {
  const { signIn, loading } = useAuth();

  return (
    <div className="state-wrap">
      <div className="state-card">
        <div className="state-ico warn" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2l7 4v6c0 5-3 9-7 10C8 21 5 17 5 12V6l7-4z" />
            <path d="M12 7v6" />
            <path d="M12 17h.01" />
          </svg>
        </div>

        <div className="state-title">You are Not Allowed to Sign In to this Application.</div>
        <div className="state-sub">
          Please contact your System Administrator
          <br />
          for further support.
        </div>

        <Button
          variant="primary"
          className="state-btn"
          disabled={loading}
          onClick={() => {
            // Always land on the home page after relogin — never the page that got them
            // here, since that page is exactly what triggered /unauthorized in the first place.
            void signIn(DEFAULT_POST_AUTH_PATH, { promptLogin: true });
          }}
        >
          Return to Sign In
        </Button>
      </div>
    </div>
  );
}

